var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card mt-3 bg-statusWarning" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "span",
            {
              staticClass: "mb-0 pb-0",
              attrs: { "data-test-hook": "payment-account-needs-attention" }
            },
            [
              _c("i", {
                staticClass: "far fa-triangle-exclamation pr-2",
                attrs: {
                  "data-test-hook": "payment-account-needs-attention-icon"
                }
              }),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1rem", "font-weight": "bold" },
                  attrs: {
                    "data-test-hook": "payment-account-needs-attention-text"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")))]
              )
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "row mb-2 ml-2" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "span",
            { attrs: { "data-test-hook": "payment-method-issue-header-text" } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "xPaymentMethodIssuePleaseUpdateOrPlanWillBeCanceled",
                      {
                        date: _vm
                          .$moment(
                            _vm.dunningSubscription?.subscriptionDunningDate
                          )
                          .format(_vm.$t("xShortDate"))
                      }
                    )
                  ) +
                  " "
              )
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "row ml-2" }, [
        _c("div", { staticClass: "col" }, [
          _vm.isSubOnAppleStore
            ? _c(
                "span",
                {
                  attrs: {
                    "data-test-hook": "apple-payment-method-issue-body-text"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xPlanOnAppleUpdateYourPaymentMethod")) +
                      " "
                  )
                ]
              )
            : _vm.isSubOnGoogleStore
            ? _c(
                "span",
                {
                  attrs: {
                    "data-test-hook": "google-payment-method-issue-body-text"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xPlanOnGoogleUpdateYourPaymentMethod")) +
                      " "
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-warning btn-update",
                  attrs: {
                    type: "button",
                    "data-test-hook": "web-payment-method-issue-button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openPaymentInformation()
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("xUpdatePaymentInformation")) + " "
                  )
                ]
              )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }